import { connect } from 'react-redux';
import { setDates } from '../store/date/actions';
import RangeView from '../components/GraphView/RangeView';

const mapStateToProps = (state, props) => {
  const params = props.url && new URLSearchParams(props.url);
  return {
    defaultActiveFilters: props.url
      ? JSON.parse(params.get('activeFilters'))
      : [
          {
            stattype: undefined,
            system: undefined,
            leadtime: undefined,
            area: undefined,
            source: undefined,
            stat: undefined,
            level: undefined,
          },
        ],
    dateRange: props.url
      ? JSON.parse(params.get('dateRange'))
      : state.dateRange,
    colors: state.style.markers,
    statsStyles: state.style.stats,
  };
};

const mapDispatchToProps = dispatch => ({
  setDates: dates => dispatch(setDates(dates)),
});

const RangePage = connect(mapStateToProps, mapDispatchToProps)(RangeView);

export default RangePage;
